
import Header from '@/components/header.vue';
import { defineComponent, reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  Form,
  Icon,
  Field,
  CellGroup,
  Cell,
  Calendar,
  ActionSheet,
  Button,
  Toast,
  SwipeCell,
} from 'vant';
import { getUserSelectCaseList, getUserSelectPlanList } from '@/http/addCase';

export default defineComponent({
  components: {
    [Form.name]: Form,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Calendar.name]: Calendar,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [SwipeCell.name]: SwipeCell,
    Header,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const { date } = route.query;
    // 时间选择
    const showAction = ref(false);
    const selectIndex = ref(0);
    const formData = ref([
      {
        name: '',
        name1: '',
        parentId: '',
        id: '',
      },
    ]);
    const state: any = reactive({
      showTime: false,
      showAction: false,
      actions: [],
      selectActions: {},
      palnListShow: false,
      palnList: [],
      selectPlanList: {},
      selectTiem: '',
    });
    const onDelete = (index:any) => {
      if (index === 0) {
        Toast('请至少填写一个');
        return;
      }
      formData.value.splice(index, 1);
    };
    // const formatDate = (date: any) => (`${date.getMonth() + 1}/${date.getDate()}`);
    // const onConfirm = (data: any) => {
    //   console.log(data);
    //   state.selectTiem = formatDate(data);
    // };
    const onShowTime = () => {
      state.showTime = true;
    };
    // 案件名称选额
    const onShowAction = (index: any) => {
      selectIndex.value = index;
      state.showAction = true;
    };
    const onSubmit = (errorInfo: any) => {
      console.log('failed', errorInfo);
      const ids = formData.value.map((item: any) => (item.id));
      router.push({
        path: '/caseform',
        query: {
          projectId: ids.join(','),
          time:
            date || `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
          proId: state.selectActions.id,
          type: 1,
        },
      });
    };
    // 选择项目
    const onSelect = (item: any) => {
      console.log(item);
      formData.value[selectIndex.value].name = item.name;
      formData.value[selectIndex.value].parentId = item.id;
      formData.value[0].name1 = '';
      state.showAction = false;
    };
    getUserSelectCaseList().then((res: any) => {
      const list = res.result.map((item: any) => ({
        name: item.caseName,
        id: item.id,
      }));
      state.actions = list;
    });
    // 选择事件名称
    const onShowPlanList = (index: any) => {
      selectIndex.value = index;
      if (!formData.value[index].parentId) {
        Toast('请先选择案件名称');
        return;
      }
      getUserSelectPlanList({
        projectId: formData.value[index].parentId,
      }).then((res: any) => {
        const list = res.result.map((item: any) => ({
          name: item.planName,
          id: item.id,
        }));
        state.palnList = list;
        state.palnListShow = true;
      });
    };
    const onSelectPaln = (item: any) => {
      const is = formData.value.some((data: any) => (data.id === item.id));
      if (is) {
        Toast('请勿重复选择事件名称');
        return;
      }
      formData.value[selectIndex.value].name1 = item.name;
      formData.value[selectIndex.value].id = item.id;
      state.palnListShow = false;
    };
    // 添加
    const onAdd = () => {
      formData.value.push({
        name: '',
        name1: '',
        parentId: '',
        id: '',
      });
    };
    return {
      state,
      onShowTime,
      onShowAction,
      onSubmit,
      onSelect,
      onShowPlanList,
      onSelectPaln,
      showAction,
      date,
      formData,
      onAdd,
      onDelete,
    };
  },
});
